import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";
import { simpleDeepClone } from '@phx-erp/shared';
import { I18nService } from '../../../../@core/services/i18n/i18n.service';
import { getContractLineItemTabGroup } from './contract-line-item-fallback-fields';

let cachedAddEditLineItemFallbackFields: FormlyFieldConfig[] | undefined;

/** Cached Formly config; cloned per detail instance so Formly can mutate safely. */
export function addEditLineItemFallbackFields(_i18n: I18nService): FormlyFieldConfig[] {
    cachedAddEditLineItemFallbackFields ??= createAddEditLineItemFallbackFields();
    return simpleDeepClone(cachedAddEditLineItemFallbackFields);
}

function createAddEditLineItemFallbackFields(): FormlyFieldConfig[] {
    const fields: FormlyFieldConfig[] = [
        {
            type: 'tabBootstrap',
            fieldGroup: [
                {
                    fieldGroupClassName: 'flex flex-wrap',
                    props: {
                        label: _("document-line-item.overview"),
                        icon: "fa fa-tachometer-alt",
                        translate: true,
                        attributes: {
                            'data-testid': "formly-dli-overview"
                        }
                    },
                    fieldGroup: [
                        {
                            fieldGroupClassName: 'flex flex-wrap',
                            props: {
                                label: _("document-line-item.add-edit-detail"),
                                translate: true,
                                attributes: {
                                    'data-testid': "formly-dli-add-edit-detail"
                                }
                            },
                            fieldGroup: [
                                {
                                    fieldGroupClassName: 'flex flex-wrap',
                                    className: "w-full lg:w-1/2",
                                    props: {

                                    },
                                    fieldGroup: [

                                        {

                                            key: 'description',
                                            className: "w-full md:w-1/2",
                                            type: 'input',
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.description'),
                                                translate: true,
                                                attributes: {
                                                    'data-testid': "formly-description-field"
                                                }
                                            },

                                        },

                                        {

                                            key: 'addition',
                                            className: "w-full md:w-1/2",
                                            type: 'input',
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.addition'),
                                                translate: true,
                                                attributes: {
                                                    'data-testid': "formly-addition-field"
                                                }
                                            },

                                        },
                                        {
                                            key: 'quantity',
                                            className: "w-full md:w-1/4",
                                            type: "formly-storage-quantity-input",
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.quantity'),
                                                translate: true,
                                                upDownButtons: false,
                                            }
                                        },
                                        {
                                            key: "itemPrice",
                                            className: "w-full md:w-1/4",
                                            type: "formly-product-price-info",
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.itemPrice'),
                                                translate: true,
                                                type: "number",
                                                upDownButtons: false,
                                                attributes: {
                                                    "data-testid": "formly-dli-item-price"
                                                }
                                            }
                                        },
                                        {
                                            key: 'discountPercentage',
                                            className: "w-full md:w-1/4",
                                            expressions: {
                                                "props.disable": "!!model.nonDiscountable"
                                            },
                                            type: 'input',
                                            wrappers: ['simple-title'],
                                            props: {
                                                // disabled: this.model?.nonDiscountable,
                                                label: _('document-line-item.discountPercentage'),
                                                translate: true,
                                                type: "number",
                                                upDownButtons: false,
                                                attributes: {
                                                    'data-testid': "formly-discount-percentage-field"
                                                }
                                            },
                                        },
                                        {
                                            key: 'discountPercentage2',
                                            className: "w-full md:w-1/4",
                                            expressions: {
                                                "props.disable": "!!model.nonDiscountable"
                                            },
                                            type: 'input',
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.discountPercentage2'),
                                                translate: true,
                                                type: "number",
                                                upDownButtons: false,
                                                attributes: {
                                                    'data-testid': "formly-discount-percentage-2-field"
                                                }
                                            },
                                        },
                                        {
                                            key: 'unit',
                                            className: "w-full md:w-1/4",
                                            type: 'formly-dli-unit-conversion-drop-down',
                                            props: {
                                                label: _('document-line-item.unit'),
                                                translate: true,
                                                autoLoad: false,
                                                attributes: {
                                                    'data-testid': "formly-unit-conversion-drop-down"
                                                }
                                            },
                                        },
                                        {
                                            className: "w-full md:w-1/4",
                                            key: "calculatoryCosts",
                                            type: "formly-price-input",
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.calculatory-costs'),
                                                translate: true,
                                                type: "number",
                                                upDownButtons: false,
                                                attributes: {
                                                    'data-testid': "formly-calculatory-costs-field"
                                                }
                                            }
                                        },
                                        {
                                            className: "w-full md:w-1/2",
                                            key: "storagePlace",
                                            type: "formly-storage-place-drop-down",
                                            // wrappers: ['simple-title']
                                            props: {
                                                label: _('document-line-item.storage-place'),
                                                translate: true,
                                                autoLoad: false,
                                                attributes: {
                                                    'data-testid': "formly-storage-place-drop-down"
                                                }
                                            },
                                            expressions: {
                                                "className": "formState.document?.documentDefinition?.stockAction == 'RELOCATE' ? 'w-1/2 md:w-1/4' : 'w-full md:w-1/2'"
                                            }
                                        },
                                        {
                                            key: 'relocateStoragePlaceId',
                                            className: "w-1/2 md:w-1/4",
                                            type: "formly-storage-place-drop-down",
                                            props: {
                                                label: _('warehouse.relocate-storage-place'),
                                                translate: true,
                                                autoLoad: false,
                                                attributes: {
                                                    modelMode: "IdOnly",
                                                    'data-testid': "formly-relocate-storage-place-drop-down"
                                                }
                                            },
                                            expressions: {
                                                "hide": "formState.document?.documentDefinition?.stockAction != 'RELOCATE'"
                                            }
                                        },
                                        {
                                            className: "w-full md:w-1/4",
                                            key: "priceUnit",
                                            type: 'input',
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('common.price-unit'),
                                                translate: true,
                                                type: "number",
                                                attributes: {
                                                    'data-testid': "formly-price-unit-field"
                                                }
                                            }
                                        },
                                        {
                                            className: "w-full md:w-1/4",
                                            key: "mpn",
                                            type: "input",
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.manufacturerProductNumber'),
                                                translate: true,
                                                attributes: {
                                                    'data-testid': "formly-manufacturer-product-number-field"
                                                }
                                            }
                                        },
                                        {
                                            className: "w-full md:w-1/2",
                                            key: "orderNumber",
                                            type: "input",
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.orderNumber'),
                                                translate: true,
                                                attributes: {
                                                    'data-testid': "formly-order-number-field"
                                                }
                                            }
                                        }
                                    ]
                                },
                                {
                                    fieldGroupClassName: 'flex flex-wrap',
                                    className: "w-full md:w-1/2",
                                    props: {

                                    },
                                    fieldGroup: [
                                        {
                                            key: 'nonDiscountable',
                                            className: "w-full lg:w-1/2 xl:w-1/4 mt-3",
                                            type: 'checkbox',
                                            props: {
                                                indeterminate: false,
                                                label: _('document-line-item.nonDiscountable'),
                                                translate: true,
                                                attributes: {
                                                    'data-testid': "formly-non-discountable-field"
                                                }
                                            },

                                        },
                                        {
                                            key: 'nonCashDiscountable',
                                            className: "w-full lg:w-1/2 xl:w-1/4 mt-3",
                                            type: 'checkbox',
                                            props: {
                                                indeterminate: false,
                                                label: _('document-line-item.nonCashDiscountable'),
                                                translate: true,
                                                attributes: {
                                                    'data-testid': "formly-non-cash-discountable-field"
                                                }
                                            },

                                        },
                                        {
                                            key: 'nonProvisionable',
                                            className: "w-full lg:w-1/2 xl:w-1/4 mt-3",
                                            type: 'checkbox',
                                            expressions: {
                                                hide: "formState.document?.documentDefinition?.documentDirection === 'IN'",
                                            },
                                            props: {
                                                indeterminate: false,
                                                label: _('document-line-item.nonProvisionable'),
                                                translate: true,
                                                attributes: {
                                                    'data-testid': "formly-non-provisionable-field"
                                                }
                                            }
                                        },
                                        //is optional
                                        {
                                            key: 'isOptional',
                                            className: "w-full lg:w-1/2 xl:w-1/4 mt-3",
                                            type: 'checkbox',
                                            props: {
                                                indeterminate: false,
                                                label: _('document-line-item.isOptional'),
                                                translate: true,
                                                hint: _('document-line-item.is-optional-hint'),
                                                attributes: {
                                                    'data-testid': "formly-is-optional-field"
                                                }
                                            }
                                        },
                                        {
                                            key: 'productText',
                                            className: "w-full",
                                            type: 'textarea',
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.productText'),
                                                translate: true,
                                                rows: 8,
                                                persistSize: true,
                                                attributes: {
                                                    'data-testid': "formly-product-text-field"
                                                }
                                            },

                                        },

                                    ]
                                }


                            ]
                        }

                    ]
                },

                // {
                //     fieldGroupClassName: 'flex flex-wrap',
                //     props: {
                //         label: _("document-line-item.shipping"),
                //         icon: "fa fa-truck",
                //         translate: true
                //     },
                // },
                {
                    fieldGroupClassName: 'flex flex-wrap',
                    props: {
                        label: _("document-line-item.finance"),
                        icon: "fa fa-money-bill-alt",
                        translate: true,
                        attributes: {
                            'data-testid': "formly-dli-finance"
                        }
                    },
                    fieldGroup: [
                        {
                            fieldGroupClassName: 'flex flex-wrap',
                            className: "w-full",
                            props: {

                            },
                            fieldGroup: [

                                {

                                    key: 'costCenter',
                                    className: "w-full md:w-1/3",
                                    type: 'formly-cost-centre-dropdown',
                                    wrappers: ['simple-title'],
                                    props: {
                                        label: _('document-line-item.cost-centre'),
                                        translate: true,
                                        attributes: {
                                            'data-testid': "formly-cost-centre-dropdown"
                                        }
                                    },

                                },
                                {

                                    key: 'costObject',
                                    className: "w-full md:w-1/3",
                                    type: 'formly-cost-object-dropdown',
                                    wrappers: ['simple-title'],
                                    props: {
                                        label: _('document-line-item.cost-object'),
                                        translate: true,
                                        attributes: {
                                            'data-testid': "formly-cost-object-dropdown"
                                        }
                                    },

                                },
                                {
                                    key: "assignedEmployee",
                                    className: "w-full md:w-1/3",
                                    type: "formly-employee-drop-down",
                                    props: {
                                        label: "document-line-item.assignedEmployee",
                                        translate: true,
                                        attributes: {
                                            "data-testid": "formly-employee-drop-down-representative-dli"
                                        },
                                        autoLoad: false
                                    }
                                },
                                {
                                    key: 'salesTaxCode',
                                    className: "w-full md:w-1/3",
                                    type: 'formly-sales-tax-code-drop-down',
                                    wrappers: ['simple-title'],
                                    props: {
                                        label: _('document-line-item.sales-tax-code'),
                                        translate: true,
                                        attributes: {
                                            'data-testid': "formly-sales-tax-code-drop-down"
                                        }
                                    },
                                },
                                {
                                    key: 'taxPercentage',
                                    className: "w-full md:w-1/3",
                                    type: 'input',
                                    wrappers: ['simple-title'],
                                    props: {
                                        type: "number",
                                        label: _('document-line-item.tax-percentage'),
                                        translate: true,
                                        minFractionDigits: 2,
                                        upDownButtons: false,
                                        attributes: {
                                            'data-testid': "formly-tax-percentage-field"
                                        }
                                    },
                                },
                                {
                                    key: 'account',
                                    className: "w-full md:w-1/3",
                                    type: 'input',
                                    wrappers: ['simple-title'],
                                    props: {
                                        label: _('document-line-item.account'),
                                        translate: true,
                                        attributes: {
                                            'data-testid': "formly-account-field"
                                        }
                                    },
                                }
                            ],
                        },
                    ],
                },
                {
                    fieldGroupClassName: 'flex flex-wrap',
                    props: {
                        label: _("document-line-item.shipping"),
                        icon: "fa fa-shipping-fast",
                        translate: true,
                        attributes: {
                            'data-testid': "formly-dli-shipping"
                        }
                    },
                    fieldGroup: [
                        {
                            fieldGroupClassName: 'flex flex-wrap',
                            className: "w-full",
                            props: {

                            },
                            fieldGroup: [
                                {
                                    key: 'netWeight',
                                    className: "w-full md:w-1/4",
                                    type: "input",
                                    wrappers: ['simple-title'],
                                    props: {
                                        label: _('document-line-item.net-weight'),
                                        translate: true,
                                        type: "number",
                                        minFractionDigits: 2,
                                        maxFractionDigits: 8,
                                        upDownButtons: false,
                                        attributes: {
                                            "data-testid": "formly-dli-net-weight"
                                        }
                                    },
                                },
                                {
                                    key: 'grossWeight',
                                    className: "w-full md:w-1/4",
                                    type: "input",
                                    wrappers: ['simple-title'],
                                    props: {
                                        label: _('document-line-item.gross-weight'),
                                        translate: true,
                                        type: "number",
                                        minFractionDigits: 2,
                                        maxFractionDigits: 8,
                                        upDownButtons: false,
                                        attributes: {
                                            "data-testid": "formly-dli-gross-weight"
                                        }
                                    },
                                },
                                {
                                    key: "deliveryDate",
                                    className: "w-full md:w-1/4",
                                    type: "formly-date-picker",
                                    props: {
                                        translate: true,
                                        label: "document-line-item.delivery-date",
                                        attributes: {
                                            "data-testid": "formly-dli-delivery-date"
                                        }
                                    }
                                },
                                {
                                    key: "estimatedDeliveryDate",
                                    className: "w-full md:w-1/4",
                                    type: "formly-date-picker",
                                    props: {
                                        translate: true,
                                        label: "document-line-item.delivery-date-expected",
                                        attributes: {
                                            "data-testid": "formly-dli-delivery-date-expected"
                                        }
                                    }
                                },
                                {
                                    key: 'deliveryNotes',
                                    className: "w-full",
                                    type: 'textarea',
                                    props: {
                                        label: _('document-line-item.delivery-notes'),
                                        translate: true,
                                        rows: 4,
                                        persistSize: true,
                                        attributes: {
                                            'data-testid': "formly-delivery-notes-field"
                                        }
                                    }
                                },
                            ],
                        },
                    ],
                },
                {
                    fieldGroupClassName: 'flex flex-wrap',
                    props: {
                        label: _("document-line-item.intrastat"),
                        icon: "fa fa-globe-europe",
                        translate: true,
                        attributes: {
                            'data-testid': "formly-dli-intrastat"
                        }
                    },
                    fieldGroup: [
                        {
                            fieldGroupClassName: 'flex flex-wrap',
                            className: "w-full",
                            props: {},
                            fieldGroup: [
                                {
                                    key: 'commodityCodeIdentifier',
                                    className: "w-full md:w-1/2",
                                    type: 'input',
                                    wrappers: ['simple-title'],
                                    props: {
                                        label: _('document-line-item.commodity-code'),
                                        translate: true,
                                        attributes: {
                                            'data-testid': "formly-dli-commodity-code"
                                        }
                                    },
                                },
                                {
                                    key: 'originCountryIso',
                                    className: "w-full md:w-1/2",
                                    type: 'formly-country-input',
                                    wrappers: ['simple-title'],
                                    props: {
                                        isoMode: true,
                                        label: _('document-line-item.origin-country'),
                                        translate: true,
                                        attributes: {
                                            'data-testid': "formly-dli-origin-country"
                                        },
                                        autoLoad: false
                                    },
                                },
                                {
                                    key: 'intrastatBusinessType',
                                    className: "w-full",
                                    type: 'formly-generic-enum-drop-down',
                                    wrappers: ['simple-title'],
                                    props: {
                                        label: _('document-line-item.intrastat-business-type'),
                                        translate: true,
                                        attributes: {
                                            enumName: "IntrastatBusinessType",
                                            'data-testid': "formly-dli-intrastat-business-type"
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    fieldGroupClassName: 'flex flex-wrap',
                    props: {
                        label: _("document-line-item.other"),
                        icon: "fa-solid fa-ellipsis",
                        translate: true,
                        attributes: {
                            'data-testid': "formly-dli-other"
                        }
                    },
                    fieldGroup: [
                        {
                            fieldGroupClassName: 'flex flex-wrap',
                            className: "w-full",
                            props: {

                            },
                            fieldGroup: [
                                {
                                    key: 'frozenPositionText',
                                    className: "w-full",
                                    type: 'checkbox',
                                    props: {
                                        label: _('document-line-item.frozen-position-text'),
                                        translate: true,
                                        hint: _('document-line-item.frozen-position-text-hint'),
                                        attributes: {
                                            'data-testid': "formly-frozen-position-text-field"
                                        }
                                    }
                                },
                                {
                                    key: 'internalNotes',
                                    className: "w-full",
                                    type: 'textarea',
                                    props: {
                                        label: _('document-line-item.internal-notes'),
                                        translate: true,
                                        rows: 8,
                                        persistSize: true,
                                        attributes: {
                                            'data-testid': "formly-internal-notes-field"
                                        }
                                    }
                                }
                            ],
                        },
                    ],
                },
                {
                    fieldGroupClassName: 'flex flex-wrap',
                    props: {
                        label: _("common.serial-numbers"),
                        icon: "fa fa-barcode",
                        translate: true,
                        attributes: {
                            'data-testid': "formly-dli-serial-numbers"
                        }
                    },
                    //for some reason 'expressions: { hide: ... }' isnt working
                    expressions: {
                        hide: "(model.product?.inventoryTrackingType != 'SERIAL' && model.product?.inventoryTrackingType != 'OUTBOUNDSERIAL') || model.serialStockTransactions?.length == 0"
                    },
                    fieldGroup: [
                        {
                            type: 'formly-line-item-serial-detail',
                            className: "my-2",
                            props: {
                                label: _('common.serial-numbers'),
                                translate: true,
                                attributes: {
                                    'data-testid': "formly-dli-serial-numbers-detail"
                                }
                            }
                        },
                    ],
                },
            ]
        },

    ];

    const tabBootstrap = fields[0];
    const tabs = tabBootstrap.fieldGroup;
    if (tabs) {
        const otherIndex = tabs.findIndex(
            (tab) => tab.props?.attributes?.['data-testid'] === 'formly-dli-other',
        );
        const insertAt = otherIndex >= 0 ? otherIndex : tabs.length;
        tabs.splice(insertAt, 0, getContractLineItemTabGroup());
    }

    return fields;
}
